// eslint-disable-next-line sonarjs/todo-tag -- intentional migration marker
// TODO: Replace Dashboard internal imports with '@/features/dashboard' once GO-2318 is done.
import { getDashboardApiUrl, waitForApiSync } from '@/features/dashboard';
import type { DashboardTab } from '@/features/dashboard';
import { http } from '@/services/http';

export interface CreateDashboardTabParams {
  dashboardName: string;
  tabName: string;
  payload: DashboardTab;
}

export async function createDashboardTab({
  dashboardName,
  payload
}: CreateDashboardTabParams): Promise<void> {
  await http.internal.post(getDashboardApiUrl(encodeURIComponent(dashboardName)), payload);
  await waitForApiSync();
}
